import {EventStatus, StatusListWithApproverStates} from '@hconnect/common/types'

export type EventsStatusesCount = Record<EventStatus<StatusListWithApproverStates>, number>
